import {
  INTERNAL_LINKS_CATEGORY,
  INTERNAL_LINKS_CATEGORY_TITLES,
  INTERNAL_LINKS_DATA,
} from '@lib/data/footer'
import InternalLinksCategory from './internal-links-category'
import Divider from './divider'

type InternalLinksColumnProps = {
  category: string[]
}
const InternalLinksColumn = ({ category }: InternalLinksColumnProps) => {
  return (
    <div className="flex flex-col gap-10 md:gap-5">
      {category.map((item, index) => (
        <InternalLinksCategory
          key={index}
          title={INTERNAL_LINKS_CATEGORY_TITLES[item]}
          links={INTERNAL_LINKS_DATA[item]}
          isTranslated={item !== INTERNAL_LINKS_CATEGORY.SOCIAL}
        />
      ))}
    </div>
  )
}

const {
  VISUAL_PROGRAMMING,
  CORE,
  WEB_DEV_LIB,
  CODING_TOOL,
  APP_DEV_TOOL,
  AI_PLATFORM,
  PYTHON_LIBRARY,
  VERSION_CONTROL,
  LEARNING_PATH,
  SOCIAL,
  BESTSELLING_COURSE,
  COMPANY,
  TRENDING_ARTICLE,
  PREMIUM_COURSE,
  CAMP_COURSE,
  CODING_FOR_KIDS,
} = INTERNAL_LINKS_CATEGORY
const InternalLinksFold = () => {
  const INTERNAL_LINKS = [
    [[VISUAL_PROGRAMMING], [CORE], [WEB_DEV_LIB], [CODING_TOOL]],
    [
      [VERSION_CONTROL, AI_PLATFORM],
      [APP_DEV_TOOL, PYTHON_LIBRARY],
      [LEARNING_PATH, CODING_FOR_KIDS],
      [TRENDING_ARTICLE],
    ],
    [[SOCIAL], [COMPANY], [BESTSELLING_COURSE], [PREMIUM_COURSE, CAMP_COURSE]],
  ]

  return (
    <>
      {INTERNAL_LINKS.map((rows) => (
        <>
          <div className="mt-10 md:mt-0 grid grid-cols-1 gap-10 md:grid-cols-2 xl:grid-cols-4 md:gap-x-20">
            {rows.map((category, idx) => (
              <InternalLinksColumn key={idx} category={category} />
            ))}
          </div>
          <Divider isDark />
        </>
      ))}
    </>
  )
}
export default InternalLinksFold
